<script setup lang="ts">
  import type { Location, Reservation } from '@/types/location';
  import { currentStep, goBack, goNext, steps, values } from '.';
  import { ref, watch } from 'vue';

  const props = defineProps<{ reservation: Reservation; location: Location }>();

  const form = ref<HTMLFormElement | null>(null);

  function handleSubmit() {
    if (steps.value[currentStep.value].submit === undefined) return;
    if (!props.reservation.id) return;

    steps.value[currentStep.value].submit?.(props.reservation.id);
  }

  function submitForm() {
    if (!form.value) return;

    form.value.requestSubmit();
  }

  watch(values.form.value, () => values.form.value), { deep: true };
</script>
<template>
  <KeepAlive>
    <Suspense>
      <form ref="form" @submit.prevent="goNext">
        <component :is="steps[currentStep].component" :step="steps[currentStep]" :reservation="reservation" :location="location" v-model:values="values" :title="steps[currentStep].title" :description="steps[currentStep].description" />
      </form>
    </Suspense>
  </KeepAlive>
  <footer class="footer hide">
    <div class="footer__nav">
      <div class="container">
        <div class="footer__wrap">
          <div class="footer__item">
            <template v-if="steps[currentStep].previous">
              <button @click.prevent="goBack" class="button outline">Vorige</button>
            </template>
          </div>
          <div class="footer__item">
            <p class="footer__text">
              {{ steps[currentStep].footer }}
            </p>
          </div>
          <div class="footer__item">
            <template v-if="steps[currentStep].submit">
              <button class="button" @click.prevent="handleSubmit">
                {{ steps[currentStep].button ? steps[currentStep].button : 'Volgende' }}
              </button>
            </template>
            <template v-else>
              <button @click.prevent="submitForm" class="button">
                {{ steps[currentStep].button ? steps[currentStep].button : 'Volgende' }}
              </button>
            </template>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>
